import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withRoot from '../withRoot';
import Header from '../components/Header';
import Helmet from "react-helmet"

const styles = theme => ({
  root: {
    textAlign: 'center',
    paddingTop: theme.spacing.unit * 15,
  },
});

const Index = ({ classes }) => {
  const title = "Meet Zheng Yu";
  const description = "This is my github io website!"
  return (
    <div className={classes.root}>
      <Helmet defaultTitle={`Zheng Yu`}
        meta={
          [
            { name: 'description', content: description },
            { name: 'keywords', content: 'zhengyutay, javascript, full, stack,' }
          ]
        }
        titleTemplate={`%s | Zheng Yu`}>
        <meta name="twitter:site" content="@zhengyutay" />
        <meta name="og:type" content="website" />
        <meta name="og:site_name" content="zhengyutay" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <link
          rel="canonical"
          href={`https://zhengyutay.github.io/`}
        />
        <html lang="en" />
      </Helmet>
      <Header />
    </div>
  );
}

Index.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRoot(withStyles(styles)(Index));
